import { render, staticRenderFns } from "./BillingModelToggle.vue?vue&type=template&id=18248986&"
import script from "./BillingModelToggle.vue?vue&type=script&lang=ts&"
export * from "./BillingModelToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToggle})
